export default function STEAMSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <div className="w-full h-96">
            <img 
              alt="STEAM Education - Science Technology Engineering Arts Mathematics"
              className="w-full h-full object-cover object-top"
              src="https://static.readdy.ai/image/5705871e133a048fcd13b20b6e4d74bd/49385fe676259705b5e920c54c12899c.jpeg"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
        </div>
      </div>
    </section>
  );
}